<div class="mentions-legales">
    <h2>
        Ce site est édité par :
    </h2>
    <p>
        Obexto Group | SAS au capital de 292 766 € immatriculée au RCS de Nantes sous le n° 494 151 681 | TVA
        intracommunautaire : FR7849151681
    </p>
    <p>
        Siège social : 1 rue Joseph Caille "&#64;" 44000 Nantes | Tél : 02 28 07 70 19 | Email : <a href="mailto:contact@obexto.Fr">contact&#64;obexto.fr</a> | Site
        internet : <a href="http://www.obexto.fr">www.obexto.fr</a>
    </p>
    <p>
        Directeur de la publication : SAS Obexto Group | Hébergeur : OVH Group SAS | Siège social 2 rue Kellerman –
        59100
        Roubaix | Tél : 1007
    </p>
    <p>
        Ce site n’utilise pas de cookies.
    </p>
    <h2>
        Informations quant au traitement des données personnelles (RGPD)
    </h2>
    <p>
        En qualité de responsable de traitement au titre du Règlement Européen 2016/679 sur la Protection des Données à
        Caractère Personnel, Obexto Group s’engage à protéger les données à caractère personnel de ses clients et
        partenaires conformément audit règlement.
    </p>
    <p>
        Notre délégué à Protection des Données (DPO) est joignable par mail : <a
            href="mailto:dpo@obexto.Fr">dpo&#64;obexto.fr</a>.
    </p>
    <p>
        Les personnes concernées disposent de certains droits relatifs à leurs données à caractère personnel et en
        particulier des droits d’accès, de rectification, de limitation à l’utilisation, d’opposition, d’effacement, de
        portabilité ou de réclamation.
    </p>
    <p>
        Toute réclamation est à adresser par courrier à l’attention du Service administratif : 18 rue Cardinal Richard –
        44300 Nantes ou par mail <a href="mailto:contact@obexto.fr ">contact&#64;obexto.fr </a>.
    </p>
</div>